// extracted by mini-css-extract-plugin
export var errorsContainer = "_tr-1";
export var link = "_tr-0";